<script>
import number from "@/mixins/number";
import DatePicker from "vue2-datepicker";
import dailyReportControlRules from "@/mixins/dailyReportControlRules";

export default {
  name: "CarsInputSP",
  components: {
    DatePicker,
  },
  mixins: [number, dailyReportControlRules],
  props: {
    carsByWorkOrder: {
      type: Array,
      default: () => [],
    },
    dailyReport: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    controlRules: {
      type: Object | null,
    },

  },
  methods: {
    getZzUnit(estimate) {
      return estimate.zz_unit?.unit;
    },
    getZzUnitBGColorClass(estimate) {
      return (estimate.zz_unit.id != '11');
    },
  },
}
</script>
<template>
  <b-row>
    <div class="input-sp-estimates">
      <template
        v-for="(estimate, estimateIndex) in carsByWorkOrder"
      >
        <div>
          <div class="wosdr">
            <div class="label-wosdr">{{ estimate.invoice_product_name }}</div>
            <div class="content-wosdr"  :class="{bg_notice:getZzUnitBGColorClass(estimate)}">
              <b-form-input
                class="input-field"
                @keyup="setMinNumber($event)"
                type="number"
                v-model="estimate.number_of_cars"
                min="0"
              ></b-form-input>
              <span>{{ getZzUnit(estimate) }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!carsByWorkOrder.length && !isLoading">
        <span>データなし。</span>
      </template>
    </div>
  </b-row>
</template>
<style lang="scss" scoped>
.input-sp-estimates {
  margin-bottom: 1rem;
  border: 2px solid #ccc;
  padding: 10px;
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
}

.label-wosdr {
  padding: 10px 7px;
  font-weight: bold;
  min-width: 142px;
}

.content-wosdr {
  width: 100%;
  display: flex;
  align-items: center;
}

.wosdr {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.input-field {
  flex: 1;
  width: 60%;
  margin-right: 5px;
}

.measurement {
  display: flex !important;
  align-items: center;
  margin-left: auto;
}

.measurement-btn {
  margin: 0px 0px 0px 0px !important;
}

.badge {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #14A5FD;
}

.badge.badge-icon-custom {
  color: #14A5FD;
  padding: 2px 6px;
  background-color: #f8f9fa;
  border-radius: 50%;
  font-weight: 700;
  cursor: pointer;
}

.input-sp-error {
  margin-left: -3px;
  margin-bottom: 20px;
}

.bg_notice{
  background-color: yellow;
}
</style>
